export default __webpack_public_path__ + "static/media/loyverse application.c3cb90b0.png";